import React from 'react';
import ReactDOM from 'react-dom';
import App from './App'
import './index.css'
import "lib-flexible"
import './assets/css/mixin.scss'

ReactDOM.render(<App />, document.getElementById('root'));